<ng-container *ngIf="label">
  <div class="capsule" [class.small]="small" [class.inline]="inline" [style.background-color]="backgroundColor" [class.isdryrun]="isDryRun">
      <div class="swatch" *ngIf="swatchColor" [style.background-color]="swatchColor"></div>
      {{ label }}
  </div>
</ng-container>
